import { useParams } from 'react-router-dom';
import { TeamSettingsTabs } from '../../components/teams/TeamSettingsTabs';
import { TeamStaffingRequirementsForm } from '../../components/teams/TeamStaffingRequirementsForm';

const TeamStaffingRequirementsPage: React.FC = () => {
  // TeamId is retrieved for future use when we implement API calls
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { teamId: _teamId } = useParams<{ teamId: string }>();
  
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <h1 className="text-3xl font-bold mb-6">Team Settings</h1>
      
      <TeamSettingsTabs />
      
      <TeamStaffingRequirementsForm />
    </div>
  );
};

export default TeamStaffingRequirementsPage; 